import {
  animate,
} from 'animejs'


class Enterprise {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.$enterprisePlan.find( '.quantity-container input[name=quantity]' ).trigger( 'change' )
    // this.initColorBox()
    this.updatePrice()
    this.initCounter()
  }

  cacheDOM () {
    this.$enterprisePlan = $( '.enterprise-plan' )
    this.$duration = $( '.enterprise-plan .price-selectors input[name=plan]' )
    this.$quantity = $( '.enterprise-plan .quantity-container input[name=quantity]' )
    this.$rateContainer = $( '.enterprise-plan .price-content .rate' )
    this.$add_to_cart = $( '.enterprise-plan button#add_to_cart' )
  }

  bindEvents () {
    this.handleInputChange()
    this.handlePlanDurationChange()
    this.handleAddToCart()
    this.handleCloseModal()
  }

  handleCloseModal () {
    $( '#closeModal' ).on( 'click', function () {
      const $modal = $( '#modal' )
      const $body = $( 'body' )

      $modal.removeClass( 'is-open' )
      $body.removeClass( 'modal-open' )
    } )
  }
  slugify ( str ) {
    return str
      .toLowerCase()
      .trim()
      .replace( /[^\w\s-]/g, '' )
      .replace( /[\s_-]+/g, '-' )
      .replace( /^-+|-+$/g, '' )
  }

  initColorBox () {
    const _SELF = this

    $( '.modal-plan.modal-wide' ).colorbox( {
      iframe: true,
      className: 'solid',
      width: '94%',
      height: '90%',
      maxHeight: 900,
      maxWidth: 900,
      onComplete: function ( obj ) {
        setTimeout( () => {
          const iframe = $( 'body' ).find( '.cboxIframe' ).contents()
          const plan = _SELF.$enterprisePlan.find( '.price-selectors input[name=plan]:checked' )

          iframe.find( 'input[name=qty]' ).val( parseInt( _SELF.$quantity.val() ) )
          iframe.find( `input[name=plan]` ).prop( 'checked', false )
          iframe.find( `input${ plan.attr( 'target' ) }` ).parent().find( 'label' ).click()

        }, 2000 )


      }
    } )
  }

  handleInputChange () {
    const _SELF = this

    this.$enterprisePlan.find( '.quantity-container input[name=quantity]' ).on( 'change', function ( e ) {
      const userNumber = $( this ).val()
      _SELF.$enterprisePlan.find( '.fake-input' ).text( `${ userNumber } ${ userNumber > 1 ? 'users' : 'user' }` )
      _SELF.updatePrice()
    } )
  }

  updatePrice () {
    const minimumQty = 7
    const quantity = Math.max( parseInt( this.$quantity.val() ), minimumQty )
    const $input = this.$enterprisePlan.find( '.price-selectors input[name=plan]:checked' )
    const seatPrice = $input.data( 'price' )
    const duration = $input.data( 'duration' )

    if ( minimumQty > quantity ) { return }

    try {
      const val = quantity * seatPrice * ( 'yearly' === duration ? 12 : 1 )
      this.$rateContainer.html( `$${ val }<span class="duration">/${ duration }` )
    } catch ( err ) {
      val = 0
    }
  }

  handlePlanDurationChange () {
    const _SELF = this

    this.$duration.on( 'change', function () {
      _SELF.updatePrice()
    } )
  }

  handleAddToCart () {
    const _SELF = this

    this.$add_to_cart.on( 'click', function ( e ) {
      const isAnnual = $( 'body' ).find( `input[name=plan]:checked` ).attr( 'id' )?.includes( 'annual' )

      const qty = $( 'body' ).find( 'input[name=quantity]' ).val()

      const baseUrl = $( this ).data( 'href' ) // Reset old query strings safely

      const params = $.param( {
        plan: isAnnual ? 'y' : 'm',
        qty: qty
      } )

      window.location.href = `${ baseUrl }?${ params }`
    } )
  }

  initCounter () {
    $( '.counter-section' ).appear( function () {
      $( '.counter' ).each( function () {
        const $this = $( this ),
          countTo = $this.attr( 'data-count' )

        $( { countNum: $this.text() } ).animate( {
          countNum: countTo
        },

          {

            duration: 2000,
            easing: 'linear',
            step: function () {
              $this.text( Math.floor( this.countNum ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, "," ) )
            },
            complete: function () {
              $this.text( this.countNum.toString().replace( /\B(?=(\d{3})+(?!\d))/g, "," ) )
            }

          } )
      } )
    } )

  }
}

new Enterprise()
